import { BlockOrientationFormGroup } from 'components/shared/FormGroup';
import { PercentWithUnit, PercentWithUnitSkeleton } from 'components/shared/Percent/PercentWithUnit';
import type { IntlKey } from 'locales';
import { FC, useContext } from 'react';

import { AddonMainFormContext } from '../AddonMainForm.context';
import { useExistsValidationErrorFor } from '../ValidationErrorsContext';

interface OwnProps {
  field: string;
  label?: IntlKey;
  value?: number;
  visible: boolean;
  onChange: (newValue: number | undefined) => void;
}

export const PercentField: FC<OwnProps> = ({ field, label = field as IntlKey, value, onChange, visible }) => {
  const hasError = useExistsValidationErrorFor(field);
  const { isReadOnly, isLoading } = useContext(AddonMainFormContext);
  if (!visible) {
    return null;
  }
  return (
    <BlockOrientationFormGroup inputId={field} label={label}>
      {!isLoading && (
        <PercentWithUnit
          isDisabled={isReadOnly}
          e2e={field}
          hasError={hasError}
          value={value}
          onChange={onChange}
          precision={4}
        />
      )}
      {isLoading && <PercentWithUnitSkeleton />}
    </BlockOrientationFormGroup>
  );
};
